import React, { useEffect } from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import Home from "../pages/HomePage/HomePage";
import AccountDetailPage from "../pages/AccountDetail/AccountDetailPage";

import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from '../../authProvider';

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"

const ProtectedComponent = ({ children }) => {
  const { instance } = useMsal();

  // Auto-redirect to Microsoft login when not authenticated
  useEffect(() => {
    const accounts = instance.getAllAccounts();
    if (accounts.length === 0) {
      instance.loginRedirect(loginRequest);
    }
  }, [instance]);

  return (
    <AuthenticatedTemplate>
      {children}
    </AuthenticatedTemplate>
  );
};

const Main = () => (
  <div>
    <main>
      <Routes> 
            <Route path="/requests/:id" element={
              <ProtectedComponent>
                <AccountDetailPage />
              </ProtectedComponent>
            } />
            <Route path="/requests/*" element={
              <ProtectedComponent>
                <Home />
              </ProtectedComponent>
            } />
            <Route path="/" element={<Navigate to="/requests" replace={true} />} />    
      </Routes>       
    </main>
  </div>
);

export default Main;
